import { defineColumns } from '@juvare/platform-shared/features/storage';
import { z } from 'zod';
export const backgroundTaskStateEntityName = 'backgroundTaskState';
export const BackgroundTaskStateSchema = z.object({
    taskName: z.string().min(1),
    lastRunTimestamp: z.number(),
});
export const columns = defineColumns({
    taskName: {
        type: 'string-required',
        index: 'unique',
    },
    lastRunTimestamp: {
        type: 'number-required',
    },
});
